import { GraphQLError, GraphQLFormattedError } from 'graphql';

type AllowedError = GraphQLError | GraphQLFormattedError;

type ErrorWithException = AllowedError & {
  readonly extensions: {
    exception: {
      status?: number;
      [key: string]: unknown;
    };
    [key: string]: unknown;
  };
};

const hasExceptionStatus = (error: AllowedError): error is ErrorWithException =>
  Boolean(
    (error as unknown as Record<string, unknown>).extensions &&
      (error as unknown as Record<string, unknown>).extensions &&
      (error as unknown as Record<string, unknown>).extensions !== undefined &&
      (
        error as {
          extensions?: { exception?: { status?: number } };
        }
      ).extensions?.exception?.status !== undefined,
  );

export const isLoggedOut = (errors: readonly AllowedError[]): boolean => {
  const isUnauthorized = errors.some(
    (error) => error.message && error.message === 'Unauthorized',
  );
  if (isUnauthorized) return true;

  const errorCodes = errors
    .filter((error) => hasExceptionStatus(error))
    .map((error) => {
      const errorWithException = error as ErrorWithException;
      return errorWithException.extensions.exception.status;
    });
  return errorCodes.some((code) => code === 401);
};
